export default __webpack_public_path__ + "static/media/play.621d57dd.svg";